interface Props {
  title: string
  hint?: string
}

// Centered full-screen message for the consent screen's terminal states
// (bad link / expired / not-author).
export const ConsentMessage = ({ title, hint }: Props) => (
  <div className="flex min-h-dvh flex-col items-center justify-center gap-2 bg-background p-6 text-center">
    <p className="text-lg font-semibold text-foreground">{title}</p>
    {hint ? <p className="max-w-sm text-sm text-muted-foreground">{hint}</p> : null}
  </div>
)
